import { Button } from "../../../design/button";
import {
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "../../../design/dialog";

interface Props {
  onClose?: () => void;
  onSelectPlaid?: () => void;
  onSelectManual?: () => void;
}

const ChooseIntegrationStep: React.FC<Props> = ({
  onClose,
  onSelectPlaid,
  onSelectManual,
}) => {
  return (
    <>
      <DialogTitle>
        How would you like to add your financial information?
      </DialogTitle>
      <DialogDescription>
        You can securely connect your financial accounts to import balances and
        transactions automatically, or start from scratch and enter your
        information manually.
      </DialogDescription>
      <DialogBody>
        <Button onClick={onSelectPlaid} className="w-full">
          Connect Financial Accounts with Plaid
        </Button>
        <Button plain onClick={onSelectManual} className="w-full">
          Enter Information Manually
        </Button>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Back
        </Button>
      </DialogActions>
    </>
  );
};

export default ChooseIntegrationStep;
